"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscribeInvoiceDto = void 0;
const common_contracts_1 = require("@inspiral/common-contracts");
const class_validator_1 = require("class-validator");
const enums_1 = require("../enums");
var SubscribeInvoiceDto;
(function (SubscribeInvoiceDto) {
    class Request {
    }
    __decorate([
        (0, class_validator_1.IsEnum)(enums_1.PlanNames),
        __metadata("design:type", String)
    ], Request.prototype, "planName", void 0);
    __decorate([
        (0, class_validator_1.IsOptional)(),
        (0, class_validator_1.IsString)(),
        __metadata("design:type", String)
    ], Request.prototype, "promocode", void 0);
    __decorate([
        (0, class_validator_1.IsEnum)(enums_1.PaymentPeriods),
        __metadata("design:type", String)
    ], Request.prototype, "paymentPeriod", void 0);
    __decorate([
        (0, class_validator_1.IsMongoId)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", String)
    ], Request.prototype, "referralProgramId", void 0);
    __decorate([
        (0, class_validator_1.IsArray)(),
        (0, class_validator_1.IsOptional)(),
        (0, class_validator_1.IsEnum)(enums_1.AddonNames, { each: true }),
        __metadata("design:type", Array)
    ], Request.prototype, "addonNames", void 0);
    __decorate([
        (0, class_validator_1.IsArray)(),
        (0, class_validator_1.IsOptional)(),
        (0, class_validator_1.IsString)({ each: true }),
        __metadata("design:type", Array)
    ], Request.prototype, "addonTitles", void 0);
    SubscribeInvoiceDto.Request = Request;
    class SubscribeInvoiceResponsePayload {
    }
    class Response extends common_contracts_1.CommonResponseWithPayload {
    }
    SubscribeInvoiceDto.Response = Response;
})(SubscribeInvoiceDto || (exports.SubscribeInvoiceDto = SubscribeInvoiceDto = {}));
//# sourceMappingURL=subscribe-invoice.dto.js.map